var F2Apps = function(appConfig) {
	this.appConfig = appConfig;
};

F2Apps.prototype.init = function() {

	var renderingToken = F2.AppHandlers.getToken();

	F2.AppHandlers.on(
		renderingToken,
		F2.Constants.AppHandlers.APP_RENDER,
		function(appConfig, appHtml) {
			var $appContainer = $('#' + appConfig.targetId);
			var $root = $('<div>')
				.addClass('f2-app-container')
				.append(appHtml);
			$appContainer.html($root);

			appConfig.root = $root.get(0);

			return $appContainer;
		}
	);

	// the next two app handlers take care of the loading icon
	F2.AppHandlers.on(
		renderingToken,
		F2.Constants.AppHandlers.APP_RENDER_BEFORE,
		function(/*appConfig*/) {}
	);

	F2.AppHandlers.on(
		renderingToken,
		F2.Constants.AppHandlers.APP_RENDER_AFTER,
		function(appConfig) {
			var $appContainer = $('#' + appConfig.targetId);
			$appContainer.trigger('loaded');
			//MOD.WfEasyXdm.sendWindowSize();
		}
	);

	F2.init({
		xhr: function(url, appConfigs, success, error, complete) {
			var params = F2.stringify(appConfigs, F2.appConfigReplacer);
			$.ajax({
				url: url,
				type: 'POST',
				data: {params: params},
				jsonp: false, // do not put 'callback=' in the query string
				dataType: 'json',
				success: function(appManifest) {
					success(appManifest);
					renderingErrorHandler.showErrorIfFailed(appManifest.apps);
				},
				error: error,
				complete: complete
			});
		}
	});

	F2.registerApps(this.appConfig);

	return false;
};
